//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import EmployeeLoanCompanyListView from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyList'
import EmployeeLoanCompanyCreateView from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyCreate'
import EmployeeLoanCompanyUpdateView from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyUpdate'

//
export default {
    path: 'employee_loan_company',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'employee-loan-company-list',
            component: EmployeeLoanCompanyListView,
        },
        {
            path: 'add',
            name: 'employee-loan-company-create',
            component: EmployeeLoanCompanyCreateView,
            meta: {
                title: 'Crear prestamo',
            },
        },
        {
            path: ':id',
            name: 'employee-loan-company-update',
            component: EmployeeLoanCompanyUpdateView,
            meta: {
                title: 'Detalles de prestamo',
            },
        },
    ],
    meta: {
        title: 'Prestamos de compañia',
    },
}
